/**
 * Created by joshuavisick on 10/18/15.
 */

/**
 * Portfolio grid filtering
 *
 */
;(function (pyatt, $, window, document, undefined) {

    pyatt.util = {

        /**
         * Update Browser URL/History
         *
         * @param stateObj
         * @param title
         * @param _href
         */
        urlChange : function(stateObj, title, _href) {

            // set url push change
            if (Modernizr.history) {
                // history is supported; do magical things

                //don't push state if going to the same URL
                if (location.href == _href) {
                    return;
                }

                // change the url without a page refresh and add a history entry.
                history.pushState(stateObj, null, _href);

            } else {
                // history is not supported; nothing fancy here
            }

        },


        /**
         * Adjust slider width to match browser width on mobile
         */
        adjustSliderWidth : function($container) {
            //console.log('adjustwidth');
            //only adjust on mobile view
            if ($(window).width() < 583) {
                var windowW = document.documentElement.clientWidth;
                $container.css('width', windowW);
            } else {
                $container.css('width', '');
            }
        }

    };

}(window.pyatt = window.pyatt || {}, jQuery, window, window.document));
